import React, { Component } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperInputComponent,
    FormWrapperItem,
    StatusComponent,
    ListComponent
} from "../../../common/component/Index";
import { Icon, Checkbox, Button, Cascader, Tooltip, InputNumber } from 'antd';
import Modal from '../../../common/component/Modal';
import Input from '../../../common/component/Input';
import { isEqual, get, find, toArray, groupBy, findIndex } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import SupplierCategory, { CategoryKeys } from '../../../../../models/SupplierCategory';
import { DETAIL_ACTIONS, PATHS, RATECODE, SUPPLIER_CATEGORY } from '../../../../../constants/Define';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import Wrapper from '../../../common/component/Wrapper';
import Empty, { PRESENTED_IMAGE_SIMPLE } from '../../../common/component/Empty';
import Span from '../../../common/component/Span';
import './CategoryDetail.less';
import AutoTranslate from 'containers/backend/common/component/AutoTranslate/AutoTranslate';

const defaultState = {
    action: "CREATE",
    validation: {},
};

const ListCols = ['code', 'name', 'type'];
class KeylistComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            componentTable: {
                type: {
                    key: 'type',
                    render: (type, record)=> ( type === 0 || type === 1 ) && SUPPLIER_CATEGORY.KEY_TYPE[type === 0 ? 'NUMBER' : 'STRING'].label
                },
                action: {
                    key: 'action',
                    align: 'center',
                    render: (text, record, idx)=> <Icon type="delete" style={{cursor: 'pointer'}} onClick={()=>this.removeItem(idx)}/>
                }
            },
            keyListItem: new CategoryKeys(),
            keyLists: [],
            validation: {},
            isShowAddModal: false,
            isDuplicate: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.categoryKeys && !isEqual(nextProps.categoryKeys, this.props.categoryKeys)) {
            this.setState({
                keyLists: nextProps.categoryKeys
            });
        }
    }

    onAddItem = (e) => {
        this.setState({ isShowAddModal: true, })
    }

    onAddKeyList = ()=>{
        const { keyLists, keyListItem } = this.state;
        if(this.validateKeys()){
            let indexDuplicate = keyLists.findIndex(item => item.code === keyListItem.code);
            if(indexDuplicate > -1){
                this.setState({isDuplicate: true});
            }else{
                let newArr = [
                    keyListItem,
                    ...keyLists
                ]
                this.setState({ keyLists: newArr, isShowAddModal: false, keyListItem: new CategoryKeys() })
                this.props.onChangeArrKey(newArr);
            }
        }
    }

    onChange = (fieldName, value)=>{
        const { keyListItem } = this.state;
        if(fieldName === 'code'){
            this.setState({isDuplicate: false});
        }
        keyListItem[fieldName] = value;
        this.setState({ keyListItem });
    }

    removeItem = (idx)=>{
        const { keyLists } = this.state;
        if(idx !== null){
            keyLists.splice(idx, 1);
            this.setState({ keyLists });
            this.props.onChangeArrKey(keyLists);
        }
    }

    validateKeys = ()=> {
        const { t } = this.props;
        const { keyListItem } = this.state;
        let validate = {
            required: {
                codeKey: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplierCategory.keyList.code`)),
                nameKey: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplierCategory.keyList.name`)),
            }
        };
        let valueValidate = {
            minLength: {},
        };
        const result = Func.multipleValidate({
            ...keyListItem, 
            codeKey: keyListItem.code, 
            nameKey: keyListItem.name
        }, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    renderAddKeyList = ()=>{
        const { t } = this.props;
        const { isShowAddModal, keyListItem, validation, isDuplicate } = this.state;

        return (
            <Modal
                visible={isShowAddModal}
                title={`${t('action.create')} ${t('item.supplierCategory.categoryKeys')}`}
                onOk={this.onAddKeyList}
                onCancel={() => this.setState({ isShowAddModal: false})}
            >
                <FormWrapperInputComponent
                    isRequired={ true }
                    isValidation={ true }
                    dataValidation={ keyListItem.codeKey }
                    validation={ validation.codeKey }
                    labelTitle={ t(`item.supplierCategory.keyList.code`) }
                >
                    <Input type="text"
                        autoComplete="off"
                        placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.supplierCategory.keyList.code")).toLowerCase()) }
                        className="form-control" 
                        name="name" 
                        onChange={ (e) => this.onChange('code', e.target.value) }
                        value={ keyListItem.code ? keyListItem.code : "" }
                    />
                    {isDuplicate && <div style={{color: 'red'}}>{t('item.supplierCategory.isKeyListDuplicate')}</div> }
                </FormWrapperInputComponent>
                <FormWrapperInputComponent
                    isRequired={ true }
                    isValidation={ true }
                    dataValidation={ keyListItem.nameKey }
                    validation={ validation.nameKey }
                    labelTitle={ t(`item.supplierCategory.keyList.name`) }
                >
                    <Input type="text"
                        autoComplete="off"
                        placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.supplierCategory.keyList.name")).toLowerCase()) }
                        className="form-control" 
                        name="name" 
                        onChange={ (e) => this.onChange('name', e.target.value) }
                        value={ keyListItem.name ? keyListItem.name : "" }
                    />
                </FormWrapperInputComponent>
                <FormWrapperInputComponent
                    labelTitle={ t(`item.supplierCategory.keyList.type`) }
                >
                    <AntSelect className="select-types"
                        placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.supplierCategory.keyList.type")).toLowerCase()) }
                        value={ keyListItem.type }
                        onChange={ channel => this.onChange('type', channel) }
                        style={ { width: '100%' } }
                    >
                        { 
                            toArray(SUPPLIER_CATEGORY.KEY_TYPE).map(item => {
                                return (
                                    <AntOption key={ item.id } value={ item.id }>
                                        { item.label }
                                    </AntOption>
                                )
                            })
                        }
                    </AntSelect>
                </FormWrapperInputComponent>
            </Modal>
        )
    }

    render(){
        const {
            componentTable,
            titleItemTable,
            keyLists
        } = this.state;

        const { t } = this.props;

        return (
            <div className="supplier-category-detail-page">
                {this.renderAddKeyList()}
                <div className="category-header-key-list">
                    <div className="left-policy">
                        {t(`item.supplierCategory.categoryKeys`)}
                    </div>
                    <div className="right-policy">
                        <Button
                            type="primary" 
                            onClick={this.onAddItem}
                        >
                            {t(`item.supplierCategory.add`)}
                        </Button>
                    </div>
                </div>
                <ListComponent 
                    tableKey="room-type-list"
                    classChildren="p-0" classParent="m-0"
                    rowKey={(record, k) => record.id ? record.id : k}
                    loading={{ spinning: false, size: 'large' }}
                    dataSource={ Func.getDataSource(keyLists || [], ListCols) }
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'supplierCategory.keyList'
                    })}
                />
            </div>
        )
    }
}

export default class SupplierCategoryDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            supplierCategoryDetail: this.props.supplierCategoryState.supplierCategoryDetail,
            isErrorCost: true,
            typeCheckCode: false,
            isAllowEdit: false
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    componentWillUnmount() {
        this.props.setSupplierCategoryDetail(new SupplierCategory())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.supplierCategoryState.supplierCategoryDetail && 
            !isEqual(nextProps.supplierCategoryState.supplierCategoryDetail, this.props.supplierCategoryState.supplierCategoryDetail)) {
            this.setState({
                supplierCategoryDetail: nextProps.supplierCategoryState.supplierCategoryDetail,
                action: nextProps.supplierCategoryState.supplierCategoryDetail.id ? 'UPDATE' : this.state.action
            });
        }
    }

    render() {
        const { t } = this.props;
        const { action, supplierCategoryDetail, validation, typeCheckCode, isAllowEdit } = this.state;

        return(
            <LoadingComponent spinning={false}>
                <PageListComponent>
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'supplierCategory'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.supplierCategory.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.supplierCategory.title')}`.toLowerCase()))
                        }

                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isGetItem={false}
                        action={action}
                        onClickBack={this.onClickBack}
                        submitButtonRight={true}
                    >
                        <FormWrapperItem>
                            <Wrapper className='col-md-6'>
                                <FormWrapperInputComponent
                                    isRequired={ true }
                                    isValidation={ true }
                                    dataValidation={ supplierCategoryDetail.name }
                                    validation={ validation.name }
                                    labelTitle={ t(`item.supplierCategory.nameCate`) }
                                >
                                    <Input type="text"
                                        autoComplete="off"
                                        placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.supplierCategory.nameCate")).toLowerCase()) }
                                        className="form-control" 
                                        name="name" 
                                        onChange={ (e) => this.onChange('name', e.target.value) }
                                        value={ supplierCategoryDetail.name ? supplierCategoryDetail.name : "" }
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className='col-md-6'>
                                <FormWrapperInputComponent
                                    isRequired={ true }
                                    isValidation={ true }
                                    dataValidation={ supplierCategoryDetail.code }
                                    validation={ validation.code }
                                    labelTitle={ t(`item.supplierCategory.codeCate`) }
                                >
                                    <Input type="text"
                                        disabled={isAllowEdit}
                                        autoComplete="off"
                                        placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.supplierCategory.codeCate")).toLowerCase()) }
                                        className="form-control" 
                                        name="code" 
                                        onChange={ (e) => this.onChange('code', e.target.value) }
                                        value={ supplierCategoryDetail.code ? supplierCategoryDetail.code : "" }
                                    />
                                    { typeCheckCode && <span style={{color: 'red'}}>{t("item.supplierCategory.invalidCode")}</span>}
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className='col-md-6'>
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.supplierCategory.descriptionCate`)}
                                >
                                    <Input.TextArea rows={3} placeholder="" type={`text`}
                                        className='form-control'
                                        name='description' 
                                        onChange={(e) => this.onChange('description', e.target.value)}
                                        value={supplierCategoryDetail.description} 
                                    />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className='col-md-6'>
                                <KeylistComponent 
                                    { ...this.props }
                                    categoryKeys={supplierCategoryDetail.categoryKeys}
                                    onChangeArrKey={this._onChangeArrKey}
                                />
                            </Wrapper>
                            {(action === DETAIL_ACTIONS.UPDATE) && (
                                <AutoTranslate
                                    className="wrapper-full supplier-category"
                                    languageCode={supplierCategoryDetail?.languageCode || 'vi-VN'}
                                    onChange={this.onChange}
                                    targetLanguage={supplierCategoryDetail?.targetLanguage}
                                />
                            )}
                        </FormWrapperItem>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        )
    }

    initDetail() {
        const { match, supplierCategoryState } = this.props;
        let supplierCategoryDetail = this.state.supplierCategoryDetail;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: "UPDATE", isAllowEdit: true });
            supplierCategoryDetail = find(supplierCategoryState.supplierCategories, item => item.id === id) || supplierCategoryDetail;
            if (supplierCategoryDetail) this.setState({ supplierCategoryDetail });
            this.props.getSupplierCategoryDetail(id);
        }
    }

    _onChangeArrKey = (arrKeys)=>{
        this.onChange('categoryKeys', arrKeys);
    }

    onChange = (fieldName, value)=>{
        const supplierCategoryDetail = this.state.supplierCategoryDetail;
        supplierCategoryDetail[fieldName] = value;
        if(fieldName === 'code'){
            this.onCheckDefineCode(value);
        }
        this.setState({ supplierCategoryDetail });
    }

    onCheckDefineCode = (value)=>{
        let isCheck = false;
        let length = value.length || 0;
        if(length > 5 || length < 3){
            isCheck = true;
        }
        this.setState({typeCheckCode: isCheck});
    }

    onSubmit = (e) => {
        e.preventDefault();

        if (this.validate()) {
            const { supplierCategoryDetail, action, typeCheckCode } = this.state;
            if(!typeCheckCode && supplierCategoryDetail.code.length <= 5 && supplierCategoryDetail.code.length >= 3){
                if(action === 'CREATE'){
                    this.props.createSupplierCategoryAction(supplierCategoryDetail);
                }else{
                    this.props.updateSupplierCategoryAction(supplierCategoryDetail);
                }
            }
        }
    };

    onClickBack = () => {
        this.props.history.push(PATHS.SUPPLIER_CATEGORY.LIST.path);
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplierCategory.nameCate`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.supplierCategory.codeCate`)),
            }
        };
        let valueValidate = {
            minLength: {},
        };
        const result = Func.multipleValidate(this.state.supplierCategoryDetail, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

}